module.exports = __webpack_public_path__ + "img/tools-blood-test.b0ac9dfa.png";